export default "__VITE_ASSET__8eGXmn2Z__"